import React from 'react';

import {
  BoldOutlined,
  FileImageOutlined,
  ItalicOutlined,
  LinkOutlined,
  OrderedListOutlined,
  PaperClipOutlined,
  StrikethroughOutlined,
  UnderlineOutlined,
  UnorderedListOutlined,
  SmileOutlined,
} from '@ant-design/icons';

export default {
  em: <ItalicOutlined />,
  strong: <BoldOutlined />,
  strikethrough: <StrikethroughOutlined />,
  underline: <UnderlineOutlined />,
  file: <PaperClipOutlined />,
  emoji: <SmileOutlined />,
  link: <LinkOutlined />,
  bullet_list: <UnorderedListOutlined />,
  ordered_list: <OrderedListOutlined />,
  image: <FileImageOutlined />,
};
